import React from 'react';

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      className="sc-blHHSb fTSiDe"
      viewBox="0 0 32 32"
    >
      <rect width="31" height="23" x="0.5" y="4.5" fill="#fbe7e7" stroke="#872525" rx="2.5"></rect>
      <g fill="#7a3030">
        <path d="M9.68 7.18a.75.75 0 00-1.358 0l-4 8.5a.75.75 0 001.357.64l.974-2.07h4.695l.974 2.07a.75.75 0 101.358-.64zm-2.32 5.57L9 9.26l1.643 3.49zm9.14-3c-.865 0-1.547.24-2.027.717a.75.75 0 101.056 1.063c.188-.187.516-.283.972-.283.584 0 1.074.323 1.21.757a3 3 0 00-1.21-.254c-1.516 0-2.75 1.12-2.75 2.5s1.234 2.5 2.75 2.5c.479 0 .95-.114 1.375-.336A.75.75 0 0019.25 16v-3.75c0-1.38-1.234-2.5-2.75-2.5m0 5.5c-.687 0-1.25-.45-1.25-1s.563-1 1.25-1 1.25.449 1.25 1-.562 1-1.25 1"></path>
        <path
          strokeLinecap="round"
          strokeWidth="1.153"
          d="M2.045 18.326h3.36v-.922h-2.16v-10.8h2.16v-.92h-3.36z"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1.154"
          d="M27.645 18.326h-3.36v-.922h2.16v-10.8h-2.16v-.92h3.36z"
        ></path>
        <circle cx="20.807" cy="15.922" r="0.817"></circle>
        <circle cx="23.01" cy="15.922" r="0.817"></circle>
        <circle cx="25.09" cy="15.922" r="0.817"></circle>
      </g>
      <g stroke="#020101" transform="translate(1.286 -1.896)">
        <circle
          cx="15.212"
          cy="16.58"
          r="5.431"
          fill="#efe7fb"
          fillOpacity="0.559"
          strokeWidth="0.6"
        ></circle>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="1.623"
          d="M19.427 20.761l4.94 4.94"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeWidth="2.84"
          d="M21.133 22.443l3.172 3.172"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
